import React from "react";
import moment from "moment";
import ReactTable from "react-table";
import matchSorter from "match-sorter";
import { BotonExcel } from "../Plantillas/Botones";
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelSheet;

class CierreCajaCentralizado extends React.Component {
    constructor(props) {
        super(props);
        
        const fechaActual = this.formatMomentForInput(moment());
        const fechaMinima = this.formatMomentForInput(moment().subtract(7, 'days'));
        
        this.state = {
            cajas: [],
            columns: [],
            isLoading: false,
            fechaInicio: fechaActual,
            fechaFin: fechaActual,
            fechaMinima: fechaMinima,
            fechaMaxima: fechaActual,
            idSucursal: "",
            sucursales: [],
            cajaSeleccionada: null, // Para mostrar detalles de una caja específica
            showHelp: false,
        }

        this.formatAmount = this.formatAmount.bind(this);
    }

    formatAmount = (amount) => {
        let monto = parseFloat(amount);
        if (isNaN(monto)) {
            monto = 0;
        }

        const formattedMonto = monto.toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        return `S/ ${formattedMonto}`;
    }
    
    componentDidMount = async () => {
        this.setState({
            isLoading: true
        });

        await this.fetchSucursales();
        await this.fetchTurnos();
    }

    fetchSucursales = async () => {
        try {
            const response = await fetch("/api/sucursales/SucursalEmpresa");
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            
            const sucursales = await response.json();
            const primeraSucursal = sucursales.length > 0 ? sucursales[0].IdSucursal : "";
            
            this.setState({
                sucursales: sucursales || [],
                idSucursal: primeraSucursal,
                isLoading: false
            });
            
        } catch (e) {
            console.error("Error fetching sucursales:", e);
            this.setState({
                error: "Error al cargar las sucursales",
                isLoading: false,
                sucursales: []
            });
        }
    }

    fetchTurnos = async () => {
        try {
            this.setState({ isLoading: true, error: null });
            
            let url = `/api/cajas/cajas-por-sucursal?fechaInicio=${this.state.fechaInicio}&fechaFin=${this.state.fechaFin}`;
            
            if (this.state.idSucursal) {
                url += `&idSucursal=${this.state.idSucursal}`;
            }
            
            const req = await fetch(url);
            
            if (!req.ok) {
                throw new Error(`Error ${req.status}: ${req.statusText}`);
            }
            
            const data = await req.json();
            this.setState({
                cajas: data || [],
                cajaSeleccionada: null, // Resetear caja seleccionada
                isLoading: false
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            this.setState({
                error: "Error al cargar los datos de cierre de caja",
                isLoading: false,
                cajas: []
            });
        }
    }

    // Método para calcular estadísticas generales
    calcularEstadisticasGenerales = () => {
        const { cajas } = this.state;
        
        if (!cajas || cajas.length === 0) {
            return {
                totalEfectivoSistema: 0,
                totalEfectivoUsuario: 0,
                diferenciaEfectivo: 0,
                totalYapeSistema: 0,
                totalYapeUsuario: 0,
                diferenciaYape: 0,
                totalPOSSistema: 0,
                totalPOSUsuario: 0,
                diferenciaPOS: 0,
                totalPlinSistema: 0,
                totalPlinUsuario: 0,
                diferenciaPlin: 0,
                totalOtraTarjetaSistema: 0,
                totalOtraTarjetaUsuario: 0,
                diferenciaOtraTarjeta: 0,
                totalSistema: 0,
                totalUsuario: 0,
                diferenciaTotal: 0
            };
        }

        let estadisticas = {
            totalEfectivoSistema: 0,
            totalEfectivoUsuario: 0,
            totalYapeSistema: 0,
            totalYapeUsuario: 0,
            totalPOSSistema: 0,
            totalPOSUsuario: 0,
            totalPlinSistema: 0,
            totalPlinUsuario: 0,
            totalOtraTarjetaSistema: 0,
            totalOtraTarjetaUsuario: 0
        };

        cajas.forEach(caja => {
            estadisticas.totalEfectivoSistema += parseFloat(caja.MontoFinalEfectivoSistema || 0);
            estadisticas.totalEfectivoUsuario += parseFloat(caja.MontoFinalEfectivoFisico || 0);
            estadisticas.totalYapeSistema += parseFloat(caja.MontoFinalYapeSistema || 0);
            estadisticas.totalYapeUsuario += parseFloat(caja.MontoFinalYape || 0);
            estadisticas.totalPOSSistema += parseFloat(caja.MontoFinalTarjetaVisaSistema || 0);
            estadisticas.totalPOSUsuario += parseFloat(caja.MontoFinalTarjetaVisaFisico || 0);
            estadisticas.totalPlinSistema += parseFloat(caja.MontoFinalPlinSistema || 0);
            estadisticas.totalPlinUsuario += parseFloat(caja.MontoFinalPlin || 0);
            estadisticas.totalOtraTarjetaSistema += parseFloat(caja.MontoFinalOtraTarjetaSistema || 0);
            estadisticas.totalOtraTarjetaUsuario += parseFloat(caja.MontoFinalOtraTarjetaFisico || 0);
        });

        // Calcular diferencias
        estadisticas.diferenciaEfectivo = estadisticas.totalEfectivoUsuario - estadisticas.totalEfectivoSistema;
        estadisticas.diferenciaYape = estadisticas.totalYapeUsuario - estadisticas.totalYapeSistema;
        estadisticas.diferenciaPOS = estadisticas.totalPOSUsuario - estadisticas.totalPOSSistema;
        estadisticas.diferenciaPlin = estadisticas.totalPlinUsuario - estadisticas.totalPlinSistema;
        estadisticas.diferenciaOtraTarjeta = estadisticas.totalOtraTarjetaUsuario - estadisticas.totalOtraTarjetaSistema;

        // Calcular totales generales
        estadisticas.totalSistema = 
            estadisticas.totalEfectivoSistema + 
            estadisticas.totalYapeSistema + 
            estadisticas.totalPOSSistema + 
            estadisticas.totalPlinSistema + 
            estadisticas.totalOtraTarjetaSistema;

        estadisticas.totalUsuario = 
            estadisticas.totalEfectivoUsuario + 
            estadisticas.totalYapeUsuario + 
            estadisticas.totalPOSUsuario + 
            estadisticas.totalPlinUsuario + 
            estadisticas.totalOtraTarjetaUsuario;

        estadisticas.diferenciaTotal = estadisticas.totalUsuario - estadisticas.totalSistema;

        return estadisticas;
    }

    // Método para ver detalles de una caja específica
    verDetallesCaja = (caja) => {
        this.setState({
            cajaSeleccionada: caja
        });
    }

    // Método para calcular estadísticas de una caja específica
    calcularEstadisticasCaja = (caja) => {
        if (!caja) return null;
        
        const estadisticas = {
            // Información básica
            nombreCaja: caja.NombreCaja,
            sucursal: caja.NombreSucursal,
            usuario: caja.NombreUsuario,
            supervisor: caja.NombreSupervisor || "Sin supervisor",
            fechaInicio: moment(caja.FechaInicio).format('DD/MM/YYYY HH:mm'),
            fechaCierre: caja.FechaFin ? moment(caja.FechaFin).format('DD/MM/YYYY HH:mm') : "En Curso",
            estado: caja.FechaFin ? "Cerrada" : "Abierta",
            
            // Montos
            montoInicial: parseFloat(caja.MontoInicial || 0),
            
            // Efectivo
            efectivoSistema: parseFloat(caja.MontoFinalEfectivoSistema || 0),
            efectivoUsuario: parseFloat(caja.MontoFinalEfectivoFisico || 0),
            diferenciaEfectivo: 0,
            
            // Yape
            yapeSistema: parseFloat(caja.MontoFinalYapeSistema || 0),
            yapeUsuario: parseFloat(caja.MontoFinalYape || 0),
            diferenciaYape: 0,
            
            // POS
            posSistema: parseFloat(caja.MontoFinalTarjetaVisaSistema || 0),
            posUsuario: parseFloat(caja.MontoFinalTarjetaVisaFisico || 0),
            diferenciaPOS: 0,
            
            // Plin
            plinSistema: parseFloat(caja.MontoFinalPlinSistema || 0),
            plinUsuario: parseFloat(caja.MontoFinalPlin || 0),
            diferenciaPlin: 0,
            
            // Otras tarjetas
            otraTarjetaSistema: parseFloat(caja.MontoFinalOtraTarjetaSistema || 0),
            otraTarjetaUsuario: parseFloat(caja.MontoFinalOtraTarjetaFisico || 0),
            diferenciaOtraTarjeta: 0,
            
            // Totales
            totalSistema: 0,
            totalUsuario: 0,
            diferenciaTotal: 0,
            
            // Otras estadísticas
            tunki: parseFloat(caja.MontoFinalTunki || 0),
            rappi: parseFloat(caja.MontoFinalRappi || 0),
            fpay: parseFloat(caja.MontoFinalFpay || 0),
            pedidos: parseFloat(caja.MontoFinalPedidos || 0)
        };

        // Calcular diferencias
        estadisticas.diferenciaEfectivo = estadisticas.efectivoUsuario - estadisticas.efectivoSistema;
        estadisticas.diferenciaYape = estadisticas.yapeUsuario - estadisticas.yapeSistema;
        estadisticas.diferenciaPOS = estadisticas.posUsuario - estadisticas.posSistema;
        estadisticas.diferenciaPlin = estadisticas.plinUsuario - estadisticas.plinSistema;
        estadisticas.diferenciaOtraTarjeta = estadisticas.otraTarjetaUsuario - estadisticas.otraTarjetaSistema;

        // Calcular totales
        estadisticas.totalSistema = 
            estadisticas.efectivoSistema + 
            estadisticas.yapeSistema + 
            estadisticas.posSistema + 
            estadisticas.plinSistema + 
            estadisticas.otraTarjetaSistema;

        estadisticas.totalUsuario = 
            estadisticas.efectivoUsuario + 
            estadisticas.yapeUsuario + 
            estadisticas.posUsuario + 
            estadisticas.plinUsuario + 
            estadisticas.otraTarjetaUsuario;

        estadisticas.diferenciaTotal = estadisticas.totalUsuario - estadisticas.totalSistema;

        return estadisticas;
    }

    getResumenPorCaja = () => {
        const { cajas } = this.state;
        
        if (!cajas || cajas.length === 0) return [];

        return cajas.map(caja => {
            const estadisticas = this.calcularEstadisticasCaja(caja);
            return {
                id: caja.IdTurnoCaja,
                nombreCaja: caja.NombreCaja,
                usuario: caja.NombreUsuario,
                estado: caja.FechaFin ? "Cerrada" : "Abierta",
                efectivoSistema: estadisticas.efectivoSistema,
                efectivoUsuario: estadisticas.efectivoUsuario,
                diferenciaEfectivo: estadisticas.diferenciaEfectivo,
                totalSistema: estadisticas.totalSistema,
                totalUsuario: estadisticas.totalUsuario,
                diferenciaTotal: estadisticas.diferenciaTotal,
                rawData: caja
            };
        });
    }

    onChangeSucursal = (e) => {
        const selectedSucursalId = e.target.value;
        this.setState({ 
            idSucursal: selectedSucursalId,
            cajaSeleccionada: null
        }, () => {
            this.fetchTurnos();
        });
    }

    formatMomentForInput = (momentDate) => {
        return momentDate.format("YYYY-MM-DD");
    }

    onChangeFecha = (e) => {
        const { name, value } = e.target;
        
        this.setState(prevState => {
            let newState = { [name]: value };
            
            if (name === 'fechaInicio') {
                if (value > prevState.fechaFin) {
                    newState.fechaFin = value;
                }
            } else if (name === 'fechaFin') {
                if (value < prevState.fechaInicio) {
                    newState.fechaInicio = value;
                }
            }
            
            return newState;
        }, () => {
            clearTimeout(this.fetchTimeout);
            this.fetchTimeout = setTimeout(() => {
                this.fetchTurnos();
            }, 500);
        });
    }
    
    getMaxFechaFin = () => {
        return this.formatMomentForInput(moment());
    }

    getMinFechaInicio = () => {
        return this.formatMomentForInput(moment().subtract(7, 'days'));
    }

    getMaxFechaInicio = () => {
        return this.state.fechaFin;
    }

    getMinFechaFin = () => {
        return this.state.fechaInicio;
    }
    
    sanitizeValue(value, decimals) {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "number") {
            return typeof decimals === "number" ? value.toFixed(decimals) : value.toString();
        }
        if (typeof value === "string") {
            let num = Number(value);
            if (!isNaN(num) && typeof decimals === "number") {
                return num.toFixed(decimals);
            }
            return value.trim().replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        }
        return String(value);
    }

    getDataCierreExportExcel(dataSet) {
        const dataToExport = Array.isArray(dataSet) ? dataSet : [];
        const estadisticas = this.calcularEstadisticasGenerales();
        
        return [
            {
                columns: [
                    { title: "Caja", width: { wpx: 100 }}, 
                    { title: "Sucursal", width: { wpx: 100 }},
                    { title: "Usuario", width: { wpx: 100 }},
                    { title: "Estado", width: { wpx: 80 }},
                    { title: "FechaInicio", width: { wpx: 150 }},
                    { title: "FechaCierre", width: { wpx: 150 }},
                    { title: "MontoApertura", width: { wpx: 120 }},
                    { title: "Efectivo Sis.", width: { wpx: 120 }},
                    { title: "Efectivo Usuario", width: { wpx: 120 }},
                    { title: "Dif. Efectivo", width: { wpx: 120 }},
                    { title: "Yape Sis.", width: { wpx: 100 }},
                    { title: "Yape Usuario", width: { wpx: 100 }},
                    { title: "Dif. Yape", width: { wpx: 100 }},
                    { title: "Pos Sis.", width: { wpx: 100 }},
                    { title: "Pos Usuario", width: { wpx: 100 }},
                    { title: "Dif. POS", width: { wpx: 100 }},
                    { title: "Plin Sis.", width: { wpx: 100 }},
                    { title: "Plin Usuario", width: { wpx: 100 }},
                    { title: "Dif. Plin", width: { wpx: 100 }},
                    { title: "O. Tarjeta Sis.", width: { wpx: 120 }},
                    { title: "O. Tarjeta Usuario", width: { wpx: 120 }},
                    { title: "Dif. O. Tarjeta", width: { wpx: 120 }},
                    { title: "Total Sistema", width: { wpx: 120 }},
                    { title: "Total Usuario", width: { wpx: 120 }},
                    { title: "Dif. Total", width: { wpx: 120 }},
                ],
                data: dataToExport.map(row => {
                    const estadisticasCaja = this.calcularEstadisticasCaja(row);
                    return [
                        { value: this.sanitizeValue(row.NombreCaja), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.NombreSucursal), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.NombreUsuario), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.FechaFin ? "Cerrada" : "Abierta"), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(moment(row.FechaInicio).format('DD/MM/YYYY HH:mm')), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.FechaFin ? moment(row.FechaFin).format('DD/MM/YYYY HH:mm') : "En Curso"), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoInicial), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalEfectivoSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalEfectivoFisico), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaEfectivo, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaEfectivo >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalYapeSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalYape), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaYape, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaYape >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaVisaSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaVisaFisico), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaPOS, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaPOS >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalPlinSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalPlin), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaPlin, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaPlin >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalOtraTarjetaSistema), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalOtraTarjetaFisico), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaOtraTarjeta, 2), style: { font: { sz: "12", bold: false, color: { rgb: estadisticasCaja.diferenciaOtraTarjeta >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.totalSistema, 2), style: { font: { sz: "12", bold: true }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.totalUsuario, 2), style: { font: { sz: "12", bold: true }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(estadisticasCaja.diferenciaTotal, 2), style: { font: { sz: "12", bold: true, color: { rgb: estadisticasCaja.diferenciaTotal >= 0 ? "008000" : "FF0000" } }, alignment: { horizontal: "left" } } },
                    ]
                })
            }
        ]
    }

    render() {
        const { cajas, isLoading, error, fecha, sucursales, idSucursal, cajaSeleccionada, showHelp } = this.state;
        const estadisticasGenerales = this.calcularEstadisticasGenerales();
        const estadisticasCajaSeleccionada = cajaSeleccionada ? this.calcularEstadisticasCaja(cajaSeleccionada) : null;
        const resumenPorCaja = this.getResumenPorCaja();

        let dataExcel = null;
        if (cajas && cajas.length > 0) {
            dataExcel = this.getDataCierreExportExcel(cajas);
        }

        return ( 
            <section className="ventas-fpay-section-vh pt-5">
                <div className="">
                    <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2">
                        <span className="align-self-center letra-fecha-fpay">
                            Desde:
                        </span>
                        <input 
                            disabled={isLoading} 
                            type="date" 
                            onChange={this.onChangeFecha}
                            name="fechaInicio"
                            className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay" 
                            value={this.state.fechaInicio}
                            min={this.getMinFechaInicio()}
                            max={this.getMaxFechaInicio()}
                        />
                        <span className="align-self-center letra-fecha-fpay">
                            Hasta:
                        </span>
                        <input 
                            disabled={isLoading} 
                            type="date" 
                            onChange={this.onChangeFecha}
                            name="fechaFin" 
                            className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                            value={this.state.fechaFin}
                            min={this.getMinFechaFin()}
                            max={this.getMaxFechaFin()}
                        />
                    </div>
                    
                    <div className="pt-3 container">
                        <div className="col-12 no-pad">
                            <div className="caja-fondo-blanco-m-2 p-3">
                                <label className="sucursal-text-color" htmlFor="sucursales">
                                    Seleccione una sucursal
                                </label>
                                <select 
                                    value={idSucursal} 
                                    name="sucursales" 
                                    id="sucursales"
                                    className="w-100 select-search-box__search"
                                    onChange={this.onChangeSucursal}
                                    disabled={isLoading || sucursales.length === 0}
                                >
                                    <option value="">-- Seleccione sucursal --</option>
                                    {sucursales.map((sucursal, index) => (
                                        <option key={index} value={sucursal.IdSucursal}>
                                            {sucursal.Nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="mb-2 pt-3">
                            <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => this.setState({ showHelp: true })}
                                title="Ver guía de uso"
                            >
                                <i className="fas fa-question-circle mr-1"/> HELP
                            </button>
                        </div>
                    </div>
                    {/* TOTALES POR TIPO DE PAGO (TOTAL GENERAL) */}
                    {cajas && cajas.length > 0 && (
                        <div className="container mt-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card" style={{background: 'rgba(255, 255, 255, 0.22)'}}>
                                        <div className="card-header d-flex justify-content-between text-white align-items-center" style={{background: '#35605a'}}>
                                            <h5 className="mb-0">
                                                <i className="fas fa-chart-bar mr-2"></i>
                                                Totales por Tipo de Pago - Todas las Cajas
                                            </h5>
                                            <span className="">{cajas.length} cajas</span>
                                        </div>
                                        <div className="card-body p-0">
                                            <table className="table table-hover mb-0">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Tipo de Pago</th>
                                                        <th className="text-center">Sistema</th>
                                                        <th className="text-center">Usuario</th>
                                                        <th className="text-center">Diferencia</th>
                                                        <th className="text-center">Estado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><strong>Efectivo</strong></td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalEfectivoSistema)}</td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalEfectivoUsuario)}</td>
                                                        <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaEfectivo >= 0 ? 'text-success' : 'text-danger'}`}>
                                                            {this.formatAmount(estadisticasGenerales.diferenciaEfectivo)}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`badge ${estadisticasGenerales.diferenciaEfectivo === 0 ? 'badge-success' : 
                                                                             estadisticasGenerales.diferenciaEfectivo > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                {estadisticasGenerales.diferenciaEfectivo === 0 ? 'OK' : 
                                                                 estadisticasGenerales.diferenciaEfectivo > 0 ? 'Sobrante' : 'Faltante'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Yape</strong></td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalYapeSistema)}</td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalYapeUsuario)}</td>
                                                        <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaYape >= 0 ? 'text-success' : 'text-danger'}`}>
                                                            {this.formatAmount(estadisticasGenerales.diferenciaYape)}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`badge ${estadisticasGenerales.diferenciaYape === 0 ? 'badge-success' : 
                                                                             estadisticasGenerales.diferenciaYape > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                {estadisticasGenerales.diferenciaYape === 0 ? 'OK' : 
                                                                 estadisticasGenerales.diferenciaYape > 0 ? 'Sobrante' : 'Faltante'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>POS</strong></td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalPOSSistema)}</td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalPOSUsuario)}</td>
                                                        <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaPOS >= 0 ? 'text-success' : 'text-danger'}`}>
                                                            {this.formatAmount(estadisticasGenerales.diferenciaPOS)}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`badge ${estadisticasGenerales.diferenciaPOS === 0 ? 'badge-success' : 
                                                                             estadisticasGenerales.diferenciaPOS > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                {estadisticasGenerales.diferenciaPOS === 0 ? 'OK' : 
                                                                 estadisticasGenerales.diferenciaPOS > 0 ? 'Sobrante' : 'Faltante'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Plin</strong></td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalPlinSistema)}</td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalPlinUsuario)}</td>
                                                        <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaPlin >= 0 ? 'text-success' : 'text-danger'}`}>
                                                            {this.formatAmount(estadisticasGenerales.diferenciaPlin)}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`badge ${estadisticasGenerales.diferenciaPlin === 0 ? 'badge-success' : 
                                                                             estadisticasGenerales.diferenciaPlin > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                {estadisticasGenerales.diferenciaPlin === 0 ? 'OK' : 
                                                                 estadisticasGenerales.diferenciaPlin > 0 ? 'Sobrante' : 'Faltante'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Otra Tarjeta</strong></td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalOtraTarjetaSistema)}</td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalOtraTarjetaUsuario)}</td>
                                                        <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaOtraTarjeta >= 0 ? 'text-success' : 'text-danger'}`}>
                                                            {this.formatAmount(estadisticasGenerales.diferenciaOtraTarjeta)}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`badge ${estadisticasGenerales.diferenciaOtraTarjeta === 0 ? 'badge-success' : 
                                                                             estadisticasGenerales.diferenciaOtraTarjeta > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                {estadisticasGenerales.diferenciaOtraTarjeta === 0 ? 'OK' : 
                                                                 estadisticasGenerales.diferenciaOtraTarjeta > 0 ? 'Sobrante' : 'Faltante'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr className="table-primary font-weight-bold">
                                                        <td><strong>TOTAL GENERAL</strong></td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalSistema)}</td>
                                                        <td className="text-center">{this.formatAmount(estadisticasGenerales.totalUsuario)}</td>
                                                        <td className={`text-center ${estadisticasGenerales.diferenciaTotal >= 0 ? 'text-success' : 'text-danger'}`}>
                                                            {this.formatAmount(estadisticasGenerales.diferenciaTotal)}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`badge ${estadisticasGenerales.diferenciaTotal === 0 ? 'badge-success' : 
                                                                             estadisticasGenerales.diferenciaTotal > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                {estadisticasGenerales.diferenciaTotal === 0 ? 'CUADRADO' : 
                                                                 estadisticasGenerales.diferenciaTotal > 0 ? 'SOBRANTE' : 'FALTANTE'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* RESUMEN POR CAJA - VISTA COMPACTA */}
                    {cajas && cajas.length > 0 && (
                        <div className="container mt-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card" style={{background: 'rgba(255, 255, 255, 0.22)'}}>
                                        <div className="card-header text-white d-flex justify-content-between align-items-center" style={{background:'#35605a'}}>
                                            <h5 className="mb-0">
                                                <i className="fas fa-cash-register mr-2"></i>
                                                Resumen por Caja
                                            </h5>
                                            <span className="">{cajas.length} registros</span>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive" style={{maxHeight: '400px', overflowY: 'auto'}}>
                                                <table className="table table-hover mb-0">
                                                    <thead className="thead-light sticky-top" style={{top: 0}}>
                                                        <tr>
                                                            <th>Caja</th>
                                                            <th>Usuario</th>
                                                            <th>Estado</th>
                                                            <th className="text-right">Efectivo Sis.</th>
                                                            <th className="text-right">Efectivo Usu.</th>
                                                            <th className="text-right">Dif. Efectivo</th>
                                                            <th className="text-right">Total Sis.</th>
                                                            <th className="text-right">Total Usu.</th>
                                                            <th className="text-right">Dif. Total</th>
                                                            <th className="text-center">Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {resumenPorCaja.map((caja, index) => (
                                                            <tr key={index} 
                                                                className={cajaSeleccionada && cajaSeleccionada.IdTurnoCaja === caja.id ? 'table-active' : ''}
                                                                style={{cursor: 'pointer'}}
                                                                onClick={() => this.verDetallesCaja(caja.rawData)}>
                                                                <td>
                                                                    <strong>{caja.nombreCaja}</strong>
                                                                </td>
                                                                <td>
                                                                    <small>{caja.usuario}</small>
                                                                </td>
                                                                <td>
                                                                    <span className={`badge ${caja.estado === 'Cerrada' ? 'badge-success' : 'badge-warning'}`}>
                                                                        {caja.estado}
                                                                    </span>
                                                                </td>
                                                                <td className="text-right">
                                                                    <small>{this.formatAmount(caja.efectivoSistema)}</small>
                                                                </td>
                                                                <td className="text-right">
                                                                    <small>{this.formatAmount(caja.efectivoUsuario)}</small>
                                                                </td>
                                                                <td className={`text-right font-weight-bold ${caja.diferenciaEfectivo >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                    <small>{this.formatAmount(caja.diferenciaEfectivo)}</small>
                                                                </td>
                                                                <td className="text-right">
                                                                    <strong>{this.formatAmount(caja.totalSistema)}</strong>
                                                                </td>
                                                                <td className="text-right">
                                                                    <strong>{this.formatAmount(caja.totalUsuario)}</strong>
                                                                </td>
                                                                <td className={`text-right font-weight-bold ${caja.diferenciaTotal >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                    <strong>{this.formatAmount(caja.diferenciaTotal)}</strong>
                                                                </td>
                                                                <td className="text-center">
                                                                    <button 
                                                                        className="btn btn-sm btn-outline-info"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            this.verDetallesCaja(caja.rawData);
                                                                        }}
                                                                        title="Ver detalles"
                                                                    >
                                                                        <i className="fas fa-eye"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* DETALLES DE CAJA SELECCIONADA */}
                    {estadisticasCajaSeleccionada && (
                        <div className="container mt-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card shadow-lg ">
                                        <div className="card-header text-white d-flex justify-content-between align-items-center" style={{background: '#35605a'}}>
                                            <h5 className="mb-0">
                                                <i className="fas fa-info-circle mr-2"></i>
                                                Detalles de Caja: {estadisticasCajaSeleccionada.nombreCaja}
                                            </h5>
                                            <button 
                                                className="btn btn-sm btn-light"
                                                onClick={() => this.setState({ cajaSeleccionada: null })}
                                            >
                                                <i className="fas fa-times"></i> Cerrar
                                            </button>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                {/* Información Básica */}
                                                <div className="col-md-4 mb-3">
                                                    <div className="card h-100">
                                                        <div className="card-header text-white" style={{background:'#01a59c'}}>
                                                            <h6 className="mb-0">Información Básica</h6>
                                                        </div>
                                                        <div className="card-body">
                                                            <p className="mb-2">
                                                                <strong>Sucursal:</strong> {estadisticasCajaSeleccionada.sucursal}
                                                            </p>
                                                            <p className="mb-2">
                                                                <strong>Usuario:</strong> {estadisticasCajaSeleccionada.usuario}
                                                            </p>
                                                            <p className="mb-2">
                                                                <strong>Estado:</strong> 
                                                                <span className={`ml-2 badge ${estadisticasCajaSeleccionada.estado === 'Cerrada' ? 'badge-success' : 'badge-warning'}`}>
                                                                    {estadisticasCajaSeleccionada.estado}
                                                                </span>
                                                            </p>
                                                            <p className="mb-0">
                                                                <strong>Fecha Inicio:</strong> {estadisticasCajaSeleccionada.fechaInicio}
                                                            </p>
                                                            <p className="mb-0">
                                                                <strong>Fecha Cierre:</strong> {estadisticasCajaSeleccionada.fechaCierre}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Montos Principales */}
                                                <div className="col-md-4 mb-3">
                                                    <div className="card h-100">
                                                        <div className="card-header text-white" style={{background:'#01a59c'}}>
                                                            <h6 className="mb-0">Montos Principales</h6>
                                                        </div>
                                                        <div className="card-body">
                                                            <p className="mb-2">
                                                                <strong>Monto Apertura:</strong> 
                                                                <strong className="float-right">{this.formatAmount(estadisticasCajaSeleccionada.montoInicial)}</strong>
                                                            </p>
                                                            <p className="mb-2">
                                                                <strong>Total Sistema:</strong> 
                                                                <strong className="float-right">{this.formatAmount(estadisticasCajaSeleccionada.totalSistema)}</strong>
                                                            </p>
                                                            <p className="mb-2">
                                                                <strong>Total Usuario:</strong> 
                                                                <strong className="float-right">{this.formatAmount(estadisticasCajaSeleccionada.totalUsuario)}</strong>
                                                            </p>
                                                            <p className="mb-0">
                                                                <strong>Diferencia Total:</strong> 
                                                                <strong className={`float-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaTotal >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                    {this.formatAmount(estadisticasCajaSeleccionada.diferenciaTotal)}
                                                                </strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Estado de Caja */}
                                                <div className="col-md-4 mb-3">
                                                    <div className="card h-100">
                                                        <div className="card-header text-white" style={{background:'#01a59c'}}>
                                                            <h6 className="mb-0">Estado de Caja</h6>
                                                        </div>
                                                        <div className="card-body text-center">
                                                            <div className={`display-4 ${estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'text-success' : 
                                                                                      estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'text-warning' : 'text-danger'}`}>
                                                                {this.formatAmount(estadisticasCajaSeleccionada.diferenciaTotal)}
                                                            </div>
                                                            <p className="mb-0">
                                                                <span className={`badge ${estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'badge-success' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                    {estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'CAJA CUADRADA' : 
                                                                     estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'SOBRANTE' : 'FALTANTE'}
                                                                </span>
                                                            </p>
                                                            <hr />
                                                            <p className="mb-0">
                                                                <small>Efectivo a entregar: {this.formatAmount(estadisticasCajaSeleccionada.efectivoSistema)}</small>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Detalles por Tipo de Pago */}
                                                <div className="col-12">
                                                    <div className="card">
                                                        <div className="card-header text-white" style={{background:'#01a59c'}}>
                                                            <h6 className="mb-0">Detalles por Tipo de Pago</h6>
                                                        </div>
                                                        <div className="card-body p-0">
                                                            <div className="table-responsive">
                                                                <table className="table table-sm mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Tipo de Pago</th>
                                                                            <th className="text-right">Sistema</th>
                                                                            <th className="text-right">Usuario</th>
                                                                            <th className="text-right">Diferencia</th>
                                                                            <th className="text-center">Estado</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td><strong>Efectivo</strong></td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.efectivoSistema)}</td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.efectivoUsuario)}</td>
                                                                            <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaEfectivo >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                                {this.formatAmount(estadisticasCajaSeleccionada.diferenciaEfectivo)}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaEfectivo === 0 ? 'badge-success' : 
                                                                                                 estadisticasCajaSeleccionada.diferenciaEfectivo > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                    {estadisticasCajaSeleccionada.diferenciaEfectivo === 0 ? 'OK' : 
                                                                                     estadisticasCajaSeleccionada.diferenciaEfectivo > 0 ? 'Sobrante' : 'Faltante'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><strong>Yape</strong></td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.yapeSistema)}</td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.yapeUsuario)}</td>
                                                                            <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaYape >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                                {this.formatAmount(estadisticasCajaSeleccionada.diferenciaYape)}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaYape === 0 ? 'badge-success' : 
                                                                                                 estadisticasCajaSeleccionada.diferenciaYape > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                    {estadisticasCajaSeleccionada.diferenciaYape === 0 ? 'OK' : 
                                                                                     estadisticasCajaSeleccionada.diferenciaYape > 0 ? 'Sobrante' : 'Faltante'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><strong>POS</strong></td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.posSistema)}</td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.posUsuario)}</td>
                                                                            <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaPOS >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                                {this.formatAmount(estadisticasCajaSeleccionada.diferenciaPOS)}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaPOS === 0 ? 'badge-success' : 
                                                                                                 estadisticasCajaSeleccionada.diferenciaPOS > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                    {estadisticasCajaSeleccionada.diferenciaPOS === 0 ? 'OK' : 
                                                                                     estadisticasCajaSeleccionada.diferenciaPOS > 0 ? 'Sobrante' : 'Faltante'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><strong>Plin</strong></td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.plinSistema)}</td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.plinUsuario)}</td>
                                                                            <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaPlin >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                                {this.formatAmount(estadisticasCajaSeleccionada.diferenciaPlin)}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaPlin === 0 ? 'badge-success' : 
                                                                                                 estadisticasCajaSeleccionada.diferenciaPlin > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                    {estadisticasCajaSeleccionada.diferenciaPlin === 0 ? 'OK' : 
                                                                                     estadisticasCajaSeleccionada.diferenciaPlin > 0 ? 'Sobrante' : 'Faltante'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><strong>Otra Tarjeta</strong></td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.otraTarjetaSistema)}</td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.otraTarjetaUsuario)}</td>
                                                                            <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaOtraTarjeta >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                                {this.formatAmount(estadisticasCajaSeleccionada.diferenciaOtraTarjeta)}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaOtraTarjeta === 0 ? 'badge-success' : 
                                                                                                 estadisticasCajaSeleccionada.diferenciaOtraTarjeta > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                    {estadisticasCajaSeleccionada.diferenciaOtraTarjeta === 0 ? 'OK' : 
                                                                                     estadisticasCajaSeleccionada.diferenciaOtraTarjeta > 0 ? 'Sobrante' : 'Faltante'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr className="table-active font-weight-bold">
                                                                            <td><strong>TOTAL</strong></td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.totalSistema)}</td>
                                                                            <td className="text-right">{this.formatAmount(estadisticasCajaSeleccionada.totalUsuario)}</td>
                                                                            <td className={`text-right ${estadisticasCajaSeleccionada.diferenciaTotal >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                                {this.formatAmount(estadisticasCajaSeleccionada.diferenciaTotal)}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <span className={`badge ${estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'badge-success' : 
                                                                                                 estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                    {estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'CUADRADA' : 
                                                                                     estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'SOBRANTE' : 'FALTANTE'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="container">

                        <div align ="right" className="seccion-btn-verde-mfp pt-3 mb-2">
                            <button style={{border:'none', background:'none'}}>

                                <ExcelFile
                                    element={
                                        <BotonExcel
                                            className="mr-2"
                                            type="button"
                                            title="Guardar Excel"
                                            />
                                    }
                                    filename={`ReporteCierreCentral_${fecha}`}
                                >
                                    <ExcelSheet
                                        dataSet={dataExcel}
                                        name="Cajas"
                                    />
                                </ExcelFile>
                            </button>
                        </div>

                        {error && (
                            <div className="alert alert-danger">
                                {error}
                            </div>
                        )}

                        {cajas && cajas.length === 0 && !isLoading && (
                            <div className="alert alert-info">
                                No se encontraron registros para los filtros seleccionados.
                            </div>
                        )}

                        <ReactTable
                            id="table-productos-to-xls"
                            data={cajas}
                            pages={-1}
                            loading={isLoading}
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]) === filter.value
                            }
                            manual={true}
                            filterable={true}
                            sortable={true}
                            columns={[
                                {
                                    columns: [
                                        {
                                            Header: "Caja",
                                            id: "Caja",
                                            width: 120,
                                            accessor: d => d.NombreCaja,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["Caja"]}),
                                            filterAll: true
                                        },
                                        // {
                                        //     Header: "Sucursal",
                                        //     id: "Sucursal",
                                        //     width: 120,
                                        //     accessor: d => d.NombreSucursal,
                                        //     filterMethod: (filter, rows) =>
                                        //         matchSorter(rows, filter.value, {keys: ["Sucursal"]}),
                                        //     filterAll: true
                                        // },
                                        {
                                            Header: "Usuario",
                                            id: "Usuario",
                                            width: 130,
                                            accessor: d => d.NombreUsuario,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["Usuario"]}),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Estado",
                                            id: "Estado",
                                            width: 100,
                                            accessor: d => d.FechaFin ? (
                                                <span className="badge badge-success">Cerrado</span>
                                            ) : (
                                                <span className="badge badge-warning">En Curso</span>
                                            ),
                                            filterAll: true
                                        },
                                        {
                                            id: 'FechaInicio',
                                            Header: 'Fecha Inicio',
                                            width: 150,
                                            accessor: d => moment(d.FechaInicio).format('DD/MM/YYYY HH:mm')
                                        },
                                        {
                                            id: 'FechaCierre',
                                            Header: 'Fecha Cierre',
                                            width: 150,
                                            accessor: d => d.FechaFin ? moment(d.FechaFin).format('DD/MM/YYYY HH:mm') : "En curso"
                                        },
                                        {
                                            id: "MontoInicial",
                                            Header: "Monto Apertura",
                                            width: 120,
                                            accessor: d => this.formatAmount(d.MontoInicial)
                                        },
                                        {
                                            Header: "Efectivo Sis.",
                                            id: "EfectivoS",
                                            width: 120,
                                            accessor: d => this.formatAmount(d.MontoFinalEfectivoSistema),
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["EfectivoS"]}),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Efectivo Usuario",
                                            id: "EfectivoU",
                                            width: 120,
                                            accessor: d => this.formatAmount(d.MontoFinalEfectivoFisico),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Dif. Efectivo",
                                            id: "DifEfectivo",
                                            width: 100,
                                            accessor: d => {
                                                const dif = parseFloat(d.MontoFinalEfectivoFisico || 0) - parseFloat(d.MontoFinalEfectivoSistema || 0);
                                                return (
                                                    <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                        {this.formatAmount(dif)}
                                                    </span>
                                                );
                                            },
                                            filterAll: true
                                        },
                                        {
                                            Header: "YAPE Sis.",
                                            id: "YapeS",
                                            width: 110,
                                            accessor: d => this.formatAmount(d.MontoFinalYapeSistema)
                                        },
                                        {
                                            Header: "YAPE Usuario",
                                            id: "YapeU",
                                            width: 110,
                                            accessor: d => this.formatAmount(d.MontoFinalYape)
                                        },
                                        {
                                            Header: "Dif. YAPE",
                                            id: "DifYape",
                                            width: 100,
                                            accessor: d => {
                                                const dif = parseFloat(d.MontoFinalYape || 0) - parseFloat(d.MontoFinalYapeSistema || 0);
                                                return (
                                                    <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                        {this.formatAmount(dif)}
                                                    </span>
                                                );
                                            }
                                        },
                                        {
                                            Header: "POS Sis.",
                                            id: "POSS",
                                            width: 110,
                                            accessor: d => this.formatAmount(d.MontoFinalTarjetaVisaSistema)
                                        },
                                        {
                                            Header: "POS Usuario",
                                            id: "POSU",
                                            width: 110,
                                            accessor: d => this.formatAmount(d.MontoFinalTarjetaVisaFisico)
                                        },
                                        {
                                            Header: "Dif. POS",
                                            id: "DifPOS",
                                            width: 100,
                                            accessor: d => {
                                                const dif = parseFloat(d.MontoFinalTarjetaVisaFisico || 0) - parseFloat(d.MontoFinalTarjetaVisaSistema || 0);
                                                return (
                                                    <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                        {this.formatAmount(dif)}
                                                    </span>
                                                );
                                            }
                                        },
                                        {
                                            Header: "Plin Sis.",
                                            id: "PlinS",
                                            width: 110,
                                            accessor: d => this.formatAmount(d.MontoFinalPlinSistema)
                                        },
                                        {
                                            Header: "Plin Usuario",
                                            id: "PlinU",
                                            width: 110,
                                            accessor: d => this.formatAmount(d.MontoFinalPlin)
                                        },
                                        {
                                            Header: "Dif. Plin",
                                            id: "DifPlin",
                                            width: 100,
                                            accessor: d => {
                                                const dif = parseFloat(d.MontoFinalPlin || 0) - parseFloat(d.MontoFinalPlinSistema || 0);
                                                return (
                                                    <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                        {this.formatAmount(dif)}
                                                    </span>
                                                );
                                            }
                                        },
                                    ]
                                }
                            ]}
                            defaultPageSize={10}
                            className="-striped -highlight"
                            previousText="Anterior"
                            nextText="Siguiente"
                            noDataText="No se encontraron registros"
                            loadingText="Cargando..."
                            ofText="de"
                            rowsText="filas"
                            pageText="Página"
                            pageSizeOptions={[10, 20, 25, 50, 100]}
                        />
                    </div>
                </div>

                {showHelp && (
                    <div
                        className="modal fade show"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header text-white" style={{ background: '#35605a' }}>
                                    <h5 className="modal-title">
                                        <i className="fas fa-book-open mr-2"/>
                                        Guía: Cierre de Caja Centralizado
                                    </h5>
                                    <button
                                        type="button"
                                        className="close text-white"
                                        onClick={() => this.setState({ showHelp: false })}
                                        aria-label="Cerrar"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                    <div className="alert alert-info">
                                        <i className="fas fa-info-circle mr-2"/>
                                        Esta guía explica el flujo completo del reporte, desde los filtros hasta la exportación.
                                    </div>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-calendar-alt mr-2"/>1. Filtros de búsqueda</h6>
                                    <p>Al ingresar verás dos campos de fecha <strong>Desde</strong> y <strong>Hasta</strong> con la fecha actual por defecto. Solo puedes consultar hasta <strong>7 días hacia atrás</strong> para optimizar el rendimiento del sistema. Las fechas se validan automáticamente: si ajustas el inicio más allá del fin, la otra fecha se actualiza en consecuencia.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-building mr-2"/>2. Selección de Sucursal</h6>
                                    <p>El selector de <strong>Sucursal</strong> se carga automáticamente al abrir la página trayendo todas las sucursales disponibles. La primera sucursal aparece seleccionada por defecto.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-sync-alt mr-2"/>3. Actualización automática</h6>
                                    <p>Al cambiar cualquier filtro (fecha o sucursal) el sistema lanza automáticamente una nueva consulta al servidor, <strong>sin necesidad de presionar ningún botón adicional</strong>. Un indicador de carga aparece mientras se procesan los datos.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-table mr-2"/>4. Totales por Tipo de Pago — Vista general</h6>
                                    <p>La primera sección muestra un resumen de <strong>todas las cajas consolidadas</strong> por método de pago: Efectivo, Yape, POS, Plin y Otras Tarjetas. Para cada fila verás:</p>
                                    <ul>
                                        <li><strong>Sistema:</strong> monto registrado por el sistema.</li>
                                        <li><strong>Usuario:</strong> monto reportado por el cajero.</li>
                                        <li><strong>Diferencia:</strong> en <span className="text-success">verde</span> si es positiva o <span className="text-danger">rojo</span> si es negativa, con etiqueta <em>OK / Sobrante / Faltante</em>.</li>
                                    </ul>
                                    <p>La última fila <strong>TOTAL GENERAL</strong> indica con una etiqueta si el consolidado de todas las cajas está <em>CUADRADO</em>, con <em>SOBRANTE</em> o con <em>FALTANTE</em>.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-cash-register mr-2"/>5. Resumen por Caja</h6>
                                    <p>La segunda sección lista individualmente cada caja con su nombre, usuario, estado (<em>Abierta / Cerrada</em>), efectivo de sistema vs usuario, diferencia de efectivo y totales generales. Haz clic en <strong>cualquier fila</strong> o en el botón <i className="fas fa-eye"/> para seleccionar esa caja y desplegar su detalle completo.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-info-circle mr-2"/>6. Detalle de Caja Seleccionada</h6>
                                    <p>Al seleccionar una caja aparece esta sección organizada en <strong>tres tarjetas</strong>:</p>
                                    <ul>
                                        <li><strong>Información básica:</strong> sucursal, usuario, estado, fechas de inicio y cierre.</li>
                                        <li><strong>Montos principales:</strong> monto de apertura, total sistema, total usuario y diferencia total con su color de estado.</li>
                                        <li><strong>Estado de caja:</strong> número destacado que indica si está <em>CUADRADA</em>, con <em>SOBRANTE</em> o con <em>FALTANTE</em>.</li>
                                    </ul>
                                    <p>Debajo de las tarjetas hay una tabla que desglosa <strong>cada tipo de pago</strong> con sistema, usuario, diferencia y estado, permitiéndote identificar exactamente en qué método existe la discrepancia.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-file-excel mr-2"/>7. Exportación a Excel</h6>
                                    <p>El botón verde de Excel genera un archivo <em>.xlsx</em> con todos los datos de las cajas. Las columnas incluyen: caja, sucursal, usuario, estado, fechas, monto de apertura, todos los tipos de pago (sistema y usuario), diferencias y totales. Las diferencias aparecen coloreadas en el Excel para facilitar su lectura.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-list mr-2"/>8. Tabla detallada</h6>
                                    <p>Al final de la pantalla encontrarás una tabla completa con todos los registros de caja. Permite <strong>filtrar y ordenar</strong> por cualquier columna, ideal para búsquedas específicas o análisis de registros puntuales. La paginación es configurable entre 10, 20, 25, 50 y 100 filas.</p>

                                    <div className="alert alert-secondary mb-0">
                                        <i className="fas fa-lightbulb mr-2 text-warning"/>
                                        <strong>Flujo recomendado:</strong> Elige fechas y sucursal → Revisa totales generales → Explora resumen por caja → Selecciona una caja para ver su detalle → Exporta a Excel si es necesario.
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => this.setState({ showHelp: false })}
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        );
    }
}

export default CierreCajaCentralizado;